import './chunk-1fafdf15.js';
import './helpers.js';
import './chunk-bd4264c6.js';
import './chunk-f647b5cb.js';
import './chunk-0928016a.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import './chunk-b59d2948.js';
import './chunk-e3b0b539.js';
import './chunk-42f463e6.js';
import './chunk-f8007af2.js';
import './chunk-5d5e2574.js';
import './chunk-01bc3886.js';
import { D as Datepicker } from './chunk-b1bc759a.js';
export { D as BDatepicker } from './chunk-b1bc759a.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Datepicker);
  }
};
use(Plugin);

export default Plugin;



//////////////////
// WEBPACK FOOTER
// ./node_modules/buefy/dist/esm/datepicker.js
// module id = null
// module chunks = 